


















































import { defineComponent, PropType } from '@vue/composition-api';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { IAdCampaign } from '@/bundles/Ad/interfaces';
import { useTable } from '@/bundles/BaseTable/composables/useTable';
import { adCampaignHeadersData } from '@/bundles/Ad/helpers';
import { AdCampaignStatus } from '@/bundles/Ad/types';
import { useAdCampaign } from '@/bundles/Ad/composables/useAdCampaign';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import AdCampaignEditForm from '@/bundles/Ad/components/AdCampaignEditForm.vue';

export default defineComponent({
  name: 'AdCampaignsListTable',

  components: {
    BaseTable,
    AdCampaignEditForm,
  },

  props: {
    tableOptionsEntry: {
      type: Object as PropType<ITableOptions>,
      required: true
    },
    itemsEntry: {
      type: Array as PropType<Array<IAdCampaign>>,
      default: () => []
    },
    totalRowsEntry: {
      type: Number,
      default: 0
    },
    loading: Boolean,
  },

  emits: ['options:change', 'items:refresh'],

  setup(_, { emit }) {
    const { calculateHeight } = useTable();

    function optionsChangeEventHandler (options: ITableOptions) {
      emit('options:change', options);
    }

    function getChipColor (status: AdCampaignStatus) {
      if (status === AdCampaignStatus.active) {
        return 'green';
      } else if (status === AdCampaignStatus.closed) {
        return 'grey';
      }
      return 'warn';
    }

    function getActionConfig (status: AdCampaignStatus) {
      if (status === AdCampaignStatus.pending || status === AdCampaignStatus.closed) {
        return {
          icon: 'mdi-check-circle',
          color: 'green',
          tip: 'Activate campaign'
        };
      }
      return {
        icon: 'mdi-close-circle',
        color: 'red',
        tip: 'Close campaign'
      };
    }

    const { changeStatus, changeStatusLoading, editLoading, editCampaign } = useAdCampaign();
    async function changeStatusWrapper(item: IAdCampaign) {
      const newStatus = item.status === AdCampaignStatus.active ? AdCampaignStatus.closed : AdCampaignStatus.active;
      await changeStatus(item.id, { status: newStatus });
      emit('items:refresh');
    }
    async function archiveCampaign (item: IAdCampaign) {
      confirm('Are you sure?') && await (async function () {
        await editCampaign(item.id, {
          active: false,
          status: item.status,
          description: item.description,
          title: item.title,
          region: item.region,
        });
        emit('items:refresh');
      })();
    }

    return {
      adCampaignHeadersData,
      changeStatusLoading,
      editLoading,
      archiveCampaign,
      getChipColor,
      getActionConfig,
      optionsChangeEventHandler,
      calculateHeight,
      changeStatusWrapper,
    };
  },
});
